import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import moment from 'moment';
import { getManagerLeads, getManagerLeadsCount } from '../../requests/get_manager_leads_request';
import {
    getManagerLeadsSuccess,
    getManagerLeadsFailure,
    countManagerLeadsSuccess,
    countManagerLeadsFailure,
    setManagerLeadManageLoading,
    setManagerLeadManageNewKey,
} from '../actions/get_manager_leads.actions';
import { GET_MANAGER_LEADS_LEAD_MANAGE } from '../constants/get_manager_leads.constants';
import { deleteKeyFromObject, extend } from '../../../../../shared/helpers';

window.moment = moment;

function* getManagerLeadsRequest({ filters, pagination }) {
    yield put(setManagerLeadManageLoading(true));

    const pagination_lead_manage = extend(false, {}, !pagination ? yield select(state => state.ManagerLeads.Manager_leads_manage.pagination) : pagination);
    const newFilters = extend(false, {}, !filters ? yield select(state => state.ManagerLeads.Manager_leads_manage.filters) : filters);
    pagination_lead_manage.page = 0;

    let where = extend(false, {}, filters, {
        is_manager_special: { $in: [null, false] },
        ref_lead_source: { $nin: ['5be93e5f683059f77dbcef4c', '5d6cd33b6f5dd301d539d68c', '5d88c66a49069a200fba697d', '5f43b26aef2c7826be53fced'] },
        ref_lead_status: { $in: ['5beabfe7f25bf5f49685abfc', '5bf2b498f83650911c3e3e80', '5beac063f25bf5f49685ac01', '5beac063f25bf5f49685ac02', '5beac063f25bf5f49685ac03'] },
        'trade.is_trade': { $in: [false] },
        deleted_date: { $exists: false },
        customer_valuation: { $gt: 1 },
        kill_manager_special: { $in: [null, false] },
    });

    where = deleteKeyFromObject(where, ['dateFrom', 'dateTo', 'marginFrom', 'marginTo', 'is_leadomatic', 'is_trade', 'ref_lead_affiliate', 'is_hot', 'hideDuplicate', 'hide_leadomatic_leads', 'customer', 'is_part_ex', 'is_trade', 'dateFrom', 'dateTo', 'vrm', 'ref_bike_brand', 'ref_bike_model', 'post_code']);

    const leads = yield call(getManagerLeads, where, pagination_lead_manage);

    if (leads.result) {
        let newResults = leads.options;
        if (leads.options.length === 0) {
            yield put(countManagerLeadsSuccess(0));
        } else {
            newResults = leads.options.filter(e => e.valuations && e.valuations.length > 0 && new moment().subtract(8, 'days').isAfter(new moment(e.valuations[e.valuations.length - 1].created_date)) && new moment().subtract(31, 'days').isBefore(new moment(e.valuations[e.valuations.length - 1].created_date)));

            if (newFilters && newFilters.dateFrom && newFilters.dateTo) {
                newResults = newResults.filter(e => e.valuations.length > 0 && e.valuations[e.valuations.length - 1] && new moment(e.valuations[e.valuations.length - 1].created_date).isBetween(newFilters.dateFrom, newFilters.dateTo));
            }

            if (newFilters && newFilters.marginFrom && newFilters.marginTo) {
                newResults = newResults.filter(e => e.valuations.length > 0 && e.valuations[e.valuations.length - 1] && ((e.valuations[e.valuations.length - 1].retail_price - e.customer_valuation) >= parseFloat(newFilters.marginFrom)) && ((e.valuations[e.valuations.length - 1].retail_price - e.customer_valuation) <= parseFloat(newFilters.marginTo)));
            }

            if (newFilters && newFilters.location) {
                newResults = newResults.filter(e => e.ref_lead_customer && e.ref_lead_customer.address && e.ref_lead_customer.address.county && e.ref_lead_customer.address.county.name.toLowerCase().includes(newFilters.location.toLowerCase()));
            }

            yield put(countManagerLeadsSuccess(newResults.length));
        }

        yield put(getManagerLeadsSuccess(newResults));
    } else {
        if (leads.error && leads.error.kind === 'number') {
            message.error('Value must be number');
        } else {
            message.error(leads.error.message);
        }
        yield put(countManagerLeadsSuccess(0));
        yield put(getManagerLeadsFailure(leads.error));
    }

    // saving where condition in redux and closing loading
    yield put(setManagerLeadManageNewKey({ data: { where, 'pagination.page': 0 } }));
    yield put(setManagerLeadManageLoading(false));
}

export default function* getManagerLeadsSaga() {
    yield takeEvery(GET_MANAGER_LEADS_LEAD_MANAGE, getManagerLeadsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/sagas/get_manager_leads.saga.js